import { render, staticRenderFns } from "./Welcome.vue?vue&type=template&id=49f50bac&scoped=true&"
var script = {}
import style0 from "./Welcome.vue?vue&type=style&index=0&id=49f50bac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49f50bac",
  null
  
)

export default component.exports